export { default as chapter } from './chapter'
export { default as contact } from './contact'
export { default as intro } from './intro'
export { default as review } from './review'
export { default as services } from './services'
export { default as team } from './team'
export { default as usps } from './usps'
